"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = void 0;
var React = require("react");
var react_1 = require("react");
var FormGroup_1 = require("./FormGroup");
var CheckBox = function (_a) {
    var id = _a.id, className = _a.className, field = _a.field, label = _a.label, autoFocus = _a.autoFocus, disabled = _a.disabled, right = _a.right, other = __rest(_a, ["id", "className", "field", "label", "autoFocus", "disabled", "right"]);
    var ref = react_1.useRef();
    field.setFieldElement({
        constraint: other,
        type: "boolean",
        focus: function () { return ref.current.focus(); },
        blur: function () { return ref.current.blur(); },
    });
    return (React.createElement(FormGroup_1.FormGroup, { label: label, invalidFeedback: field.getError() },
        React.createElement("input", { type: "checkbox", className: className || "form-control", onChange: function (e) { return field.setValue("" + e.target.checked); }, onBlur: field.onBlur, onFocus: field.onFocus, ref: ref, autoFocus: autoFocus, disabled: disabled, checked: field.getValue() == "true", id: id }),
        right));
};
exports.CheckBox = CheckBox;
